var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.BitdashVR = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    return this.player.getCurrentTime()
  },

  /** Override to return video duration */
  getDuration: function () {
    return this.player.getDuration()
  },

  /** Override to return current bitrate */
  getBitrate: function () {
    if (this.player.getPlaybackVideoData && this.player.getPlaybackVideoData()
      && this.player.getPlaybackVideoData().bitrate) {
      return this.player.getPlaybackVideoData().bitrate
    } else {
      return -1
    }
  },

  /** Override to return rendition */
  getRendition: function () {
    if (this.player.getPlaybackVideoData && this.player.getPlaybackVideoData()) {
      var playbackValues = this.player.getPlaybackVideoData()
      if (playbackValues.bitrate) {
        if (playbackValues.width && playbackValues.height) {
          return youbora.Util.buildRenditionString(playbackValues.width, playbackValues.height, playbackValues.bitrate)
        }
        return playbackValues.bitrate
      }
      return this.player.getPlaybackVideoData().id
    }
    return -1;
  },

  /** Override to recurn true if live and false if VOD */
  getIsLive: function () {
    return this.player.isLive()
  },

  /** Override to return resource URL. */
  getResource: function () {
    if (this.player.getConfig && this.player.getConfig().source.dash) {
      return this.player.getConfig().source.dash
    } else {
      return 'unknown'
    }
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    return "bitdash " + bitmovin.player.version
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    var EVENT = this.player.EVENT || bitmovin.player.EVENT
    // Console all events if logLevel=DEBUG
    youbora.Util.logAllEvents([
      null,
      EVENT.ON_AD_CLICKED,
      EVENT.ON_AD_ERROR,
      EVENT.ON_AD_FINISHED,
      EVENT.ON_AD_LINEARITY_CHANGED,
      EVENT.ON_AD_MANIFEST_LOADED,
      EVENT.ON_AD_PLAYBACK_FINISHED,
      EVENT.ON_AD_SCHEDULED,
      EVENT.ON_AD_SKIPPED,
      EVENT.ON_AD_STARTED,
      EVENT.ON_DOWNLOAD_FINISHED,
      EVENT.ON_DVR_WINDOW_EXCEEDED,
      EVENT.ON_ERROR,
      EVENT.ON_FULLSCREEN_ENTER,
      EVENT.ON_FULLSCREEN_EXIT,
      EVENT.ON_HIDE_CONTROLS,
      EVENT.ON_METADATA,
      EVENT.ON_PAUSED,
      EVENT.ON_PLAY,
      EVENT.ON_PLAYBACK_FINISHED,
      EVENT.ON_PLAYER_CREATED,
      EVENT.ON_PLAYER_RESIZE,
      EVENT.ON_READY,
      EVENT.ON_SEEK,
      EVENT.ON_SEEKED,
      EVENT.ON_SEGMENT_PLAYBACK,
      EVENT.ON_SEGMENT_REQUEST_FINISHED,
      EVENT.ON_SOURCE_LOADED,
      EVENT.ON_SOURCE_UNLOADED,
      EVENT.ON_STALL_ENDED,
      EVENT.ON_STALL_STARTED,
      EVENT.ON_TIME_CHANGED,
      EVENT.ON_TIME_SHIFT,
      EVENT.ON_TIME_SHIFTED,
      EVENT.ON_VIDEO_ADAPTATION,
      EVENT.ON_VIDEO_DOWNLOAD_QUALITY_CHANGE,
      EVENT.ON_VIDEO_DOWNLOAD_QUALITY_CHANGED,
      EVENT.ON_VIDEO_PLAYBACK_QUALITY_CHANGED,
      EVENT.ON_VR_ERROR,
      EVENT.ON_VR_MODE_CHANGED,
      EVENT.ON_WARNING,
      EVENT.ON_SEGMENT_PLAYBACK,
      EVENT.ON_STALL_ENDED,
      EVENT.ON_STALL_STARTED
    ])

    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(true, false)

    // Register listeners
    this.player.addEventHandler(EVENT.ON_PLAY, this.playListener.bind(this))
    this.player.addEventHandler(EVENT.ON_PAUSED, this.pauseListener.bind(this))
    this.player.addEventHandler(EVENT.ON_PLAYING, this.playingListener.bind(this))
    this.player.addEventHandler(EVENT.ON_ERROR, this.errorListener.bind(this))
    this.player.addEventHandler(EVENT.ON_SEEK, this.seekingListener.bind(this))
    this.player.addEventHandler(EVENT.ON_SEEKED, this.seekedListener.bind(this))
    this.player.addEventHandler(EVENT.ON_PLAYBACK_FINISHED, this.endedListener.bind(this))
    this.player.addEventHandler(EVENT.ON_SEGMENT_PLAYBACK, this.joinListener.bind(this))
    this.player.addEventHandler(EVENT.ON_STOP_BUFFERING, this.joinListener.bind(this))
    this.player.addEventHandler(EVENT.ON_TIME_CHANGED, this.joinChangedListener.bind(this))
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    this.monitor.stop()

    // unregister listeners
    this.player.removeEventHandler(EVENT.ON_PLAY, this.playListener)
    this.player.removeEventHandler(EVENT.ON_PAUSED, this.pauseListener)
    this.player.removeEventHandler(EVENT.ON_PLAYING, this.playingListener)
    this.player.removeEventHandler(EVENT.ON_ERROR, this.errorListener)
    this.player.removeEventHandler(EVENT.ON_SEEK, this.seekingListener)
    this.player.removeEventHandler(EVENT.ON_SEEKED, this.seekedListener)
    this.player.removeEventHandler(EVENT.ON_PLAYBACK_FINISHED, this.endedListener)
    this.player.removeEventHandler(EVENT.ON_SEGMENT_PLAYBACK, this.joinListener)
    this.player.removeEventHandler(EVENT.ON_STOP_BUFFERING, this.joinListener)
    this.player.removeEventHandler(EVENT.ON_TIME_CHANGED, this.joinChangedListener)
  },

  /** Listener for 'ON_PLAY' event. */
  playListener: function (e) {
    this.fireStart()
    this.fireResume()
  },

  /** Listener for 'ON_SEGMENT_PLAYBACK' and 'ON_STOP_BUFFERING' events. */
  joinListener: function (e) {
    this.fireJoin()
  },

  /** Listener for 'ON_PAUSED' event. */
  pauseListener: function (e) {
    this.firePause()
  },

  /** Listener for 'ON_PLAYING' events. */
  playingListener: function (e) {
    this.fireStart()
  },

  /** Listener for 'ON_ERROR' event. */
  errorListener: function (e) {
    this.fireError(e.code, e.message)
  },

  /** Listener for 'ON_SEEK' event. */
  seekingListener: function (e) {
    this.fireSeekBegin()
  },

  /** Listener for 'ON_SEEKED' event. */
  seekedListener: function (e) {
    this.fireSeekEnd()
  },

  /** Listener for 'ON_PLAYBACK_FINISHED' event. */
  endedListener: function (e) {
    this.fireStop()
  },

  /** Listener for 'ON_TIME_CHANGED' event*/
  joinChangedListener: function (e) {
    if (this.getPlayhead() > 0) {
      this.fireJoin()
    }
  }
})

module.exports = youbora.adapters.BitdashVR



//////////////////
// WEBPACK FOOTER
// ./src/adapter.js
// module id = 25
// module chunks = 0